import { of } from 'rxjs';
import { MemberQuery } from '../member.query';
import { MemberDetails } from './member-details.model';

export const USERCONTEXT_MOCK_FR: Partial<MemberQuery> = {
  userContext$: of({
    portalId: '',
    memberId: '',
    externalRef: '',
    populationId: '',
    populationName: '',
    clubId: 0,
    sessionId: '',
    lcid: '3084',
    status: 2,
    customerTags: [],
    clientType: 1,
    loginType: 4,
    clientAttribute: '',
    tierId: 0,
    tierName: '',
    isCheckedIn: false,
  }),
};

export const MEMBER_DETAILS_MOCK: MemberDetails = {
  PortalId: '',
  MemberId: '',
  ClubId: 0,
  TicketActionStatus: 0,
  Title: 'M',
  FirstName: 'FirstName',
  Surname: 'Surname',
  DOB: '',
  Gender: '',
  AddressType: 0,
  AddressName: 'Work',
  Street: 'Street',
  Town: 'Town',
  County: 'County',
  PostCode: 'WC1H 9LG',
  Country: 'United Kingdom',
  HomeNumber: '',
  OtherNumber: '',
  MobileNumber: '',
  EmailAddress1: '',
  EmailAddress2: '',
  LastUpdated: '',
  IsFirstTimeUser: false,
  IsAccountActive: true,
  CompanyName: 'Fortress GB',
  EntityUserLevel: 0,
  ExternalRefNumber: '',
  EventTypeId: '',
  Deleted: 0,
  LastLogin: '',
  ActivationDate: '',
  CreationDate: '',
  UpgradeDate: '',
  SpareExternalId: '',
  Username: '',
  CountyId: 0,
  CountryId: 0,
  UserAccountStatus: 0,
};
